import { ScreenLoaderBackdrop } from '@ocx/ui';

import { AllureCashbackLayout } from './allure-cashback.layout';
import { AllureCashbackRedeemPage } from './allure-cashback-redeem.page';
import { AllureCashbackSetupPage } from './allure-cashback-setup.page';
import { useAllureCashbackAccount } from './use-allure-cashback-account.hook';

export const AllureCashbackController = () => {
  const { balance, account, loading, refetch } = useAllureCashbackAccount();
  const hasBalance = typeof balance === 'number';

  return (
    <AllureCashbackLayout>
      {loading && <ScreenLoaderBackdrop open />}
      {!loading &&
        (hasBalance && account ? (
          <AllureCashbackRedeemPage
            accountUuid={account.uuid}
            balance={balance}
            cashout={account.cashout}
            onRedeemed={refetch}
            onRemoved={refetch}
          />
        ) : (
          <AllureCashbackSetupPage onLinked={refetch} />
        ))}
    </AllureCashbackLayout>
  );
};
